import {
  InputGroup,
  InputRow,
  RadioYesNoInput,
} from '@equifinance/shared';
import { PaddedSection } from '../../components/Section';
import { useAccountContext } from '../../../../contexts';

export const DisclosureRefName = 'disclosure';

export default function DisclosureSection() {
  const { account } = useAccountContext();

  const {
    applicants,
    disclosure,
    errors,
    warnings,
  } = account;

  return (
    <PaddedSection
      id={disclosure?.id}
      refName={DisclosureRefName}
      title="Disclosure"
      errors={errors}
      warnings={warnings}
    >
      <InputGroup>
        <InputRow>
          <RadioYesNoInput
            label={applicants?.length > 1
              ? 'Do any of the Applicants have or are subject to any criminal convictions?'
              : 'Does the Applicant have or is subject to any criminal convictions?'}
            field="disclosure.anyCriminalConvictions"
            required
            tooltip="Minor convictions such as speeding or fare evasion do not need to be declared."
          />
          <RadioYesNoInput
            label={applicants?.length > 1
              ? 'Have any of the Applicants had a previous property repossessed?'
              : 'Has the Applicant had a previous property repossessed?'}
            field="disclosure.anyPreviousPropertyRepossessed"
            required
          />
        </InputRow>
      </InputGroup>
    </PaddedSection>
  );
}
